module.exports = __webpack_public_path__ + "img/gnu_smart_detail.355ec3ce.jpg";